import { render, staticRenderFns } from "./SvgSprite.vue?vue&type=template&id=33de594e&scoped=true&lang=pug&"
import script from "./SvgSprite.vue?vue&type=script&lang=js&"
export * from "./SvgSprite.vue?vue&type=script&lang=js&"
import style0 from "./SvgSprite.vue?vue&type=style&index=0&id=33de594e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33de594e",
  null
  
)

export default component.exports